var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "execution" },
    [
      _c("br"),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "form",
          attrs: { model: _vm.form, "label-width": "60px", size: "mini" },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("vipCargo.por"), prop: "por" } },
                    [
                      _c("glPort", {
                        on: { change: _vm.porChange },
                        model: {
                          value: _vm.form.por,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "por", $$v)
                          },
                          expression: "form.por",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("vipCargo.pol"), prop: "pol" } },
                    [
                      _c("glPort", {
                        on: { change: _vm.polChange },
                        model: {
                          value: _vm.form.pol,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "pol", $$v)
                          },
                          expression: "form.pol",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("vipCargo.etd"), prop: "etd" } },
                    [
                      _c("el-date-picker", {
                        staticClass: "pickTime",
                        staticStyle: { width: "100%" },
                        attrs: {
                          "picker-options": _vm.pickerOptions,
                          format: "yyyy-MM-dd",
                          "value-format": "yyyy-MM-dd",
                          type: "daterange",
                          "range-separator": "To",
                        },
                        model: {
                          value: _vm.form.etd,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "etd", $$v)
                          },
                          expression: "form.etd",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("vipCargo.atd"), prop: "atd" } },
                    [
                      _c("el-date-picker", {
                        staticClass: "pickTime",
                        staticStyle: { width: "100%" },
                        attrs: {
                          "picker-options": _vm.pickerOptions,
                          format: "yyyy-MM-dd",
                          "value-format": "yyyy-MM-dd",
                          type: "daterange",
                          "range-separator": "To",
                        },
                        model: {
                          value: _vm.form.atd,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "atd", $$v)
                          },
                          expression: "form.atd",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("vipCargo.pod"), prop: "pod" } },
                    [
                      _c("glPort", {
                        on: { change: _vm.podChange },
                        model: {
                          value: _vm.form.pod,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "pod", $$v)
                          },
                          expression: "form.pod",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("vipCargo.del"), prop: "del" } },
                    [
                      _c("glPort", {
                        on: { change: _vm.delChange },
                        model: {
                          value: _vm.form.del,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "del", $$v)
                          },
                          expression: "form.del",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("vipCargo.eta"), prop: "eta" } },
                    [
                      _c("el-date-picker", {
                        staticClass: "pickTime",
                        staticStyle: { width: "100%" },
                        attrs: {
                          "picker-options": _vm.pickerOptions,
                          format: "yyyy-MM-dd",
                          "value-format": "yyyy-MM-dd",
                          type: "daterange",
                          "range-separator": "To",
                        },
                        model: {
                          value: _vm.form.eta,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "eta", $$v)
                          },
                          expression: "form.eta",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("vipCargo.ata"), prop: "ata" } },
                    [
                      _c("el-date-picker", {
                        staticClass: "pickTime",
                        staticStyle: { width: "100%" },
                        attrs: {
                          "picker-options": _vm.pickerOptions,
                          format: "yyyy-MM-dd",
                          "value-format": "yyyy-MM-dd",
                          type: "daterange",
                          "range-separator": "To",
                        },
                        model: {
                          value: _vm.form.ata,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "ata", $$v)
                          },
                          expression: "form.ata",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 5 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("vipCargo.vessel"),
                        prop: "vesselCode",
                      },
                    },
                    [
                      _c("glVesselMain", {
                        on: { change: _vm.vesselChange },
                        model: {
                          value: _vm.form.vesselCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "vesselCode", $$v)
                          },
                          expression: "form.vesselCode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("vipCargo.voyage"),
                        prop: "voyageNo",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { clearable: "" },
                        model: {
                          value: _vm.form.voyageNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "voyageNo", $$v)
                          },
                          expression: "form.voyageNo",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 5 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("vipCargo.blNo"), prop: "blNo" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "" },
                        model: {
                          value: _vm.form.blNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "blNo", $$v)
                          },
                          expression: "form.blNo",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "NAC", prop: "freightNameCn" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { filterable: "", clearable: "" },
                          model: {
                            value: _vm.form.freightNameCn,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "freightNameCn", $$v)
                            },
                            expression: "form.freightNameCn",
                          },
                        },
                        _vm._l(_vm.nacList, function (item) {
                          return _c("el-option", {
                            key: item,
                            attrs: { label: item, value: item },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                {
                  staticStyle: {
                    "padding-right": "20px",
                    "text-align": "right",
                    float: "right",
                  },
                  attrs: { span: 6 },
                },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-primary",
                      staticStyle: { width: "36%" },
                      attrs: {
                        type: "primary",
                        size: "mini",
                        icon: "el-icon-search",
                      },
                      on: { click: _vm.toSearch },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("button.search")) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-plain-primary",
                      attrs: { size: "mini", icon: "el-icon-delete" },
                      on: { click: _vm.reset },
                    },
                    [_vm._v(_vm._s(_vm.$t("vipCargo.reset")) + "\n        ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            {
              staticClass: "right-button",
              staticStyle: { "text-align": "left" },
              attrs: { span: 6 },
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn-plain-primary",
                  attrs: { size: "mini", icon: "el-icon-printer" },
                  on: {
                    click: function ($event) {
                      return _vm.printView()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("vipCargo.view")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "btn-plain-primary",
                  attrs: { size: "mini" },
                  on: {
                    click: function ($event) {
                      return _vm.exportExcel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("vipCargo.excel")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "padding-top": "10px" } },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableBaseInfoData,
                size: "mini",
                id: "out-table",
                stripe: "",
                border: "",
                height: "390",
              },
              on: {
                "row-click": _vm.rowClick,
                "selection-change": _vm.handleSelectionChange,
              },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "35" },
              }),
              _vm._v(" "),
              _c("el-table-column", { attrs: { type: "index", width: "40" } }),
              _vm._v(" "),
              _c(
                "el-table-column",
                { attrs: { label: _vm.$t("vipCargo.baseInfo") } },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "freightName",
                      label: _vm.$t("vipCargo.freightName"),
                      "min-width": "80px",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "freightNameCn",
                      label: _vm.$t("vipCargo.freightNameCn"),
                      "min-width": "80px",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "blNo",
                      label: _vm.$t("vipCargo.blNo"),
                      fixed: "",
                      "min-width": "150px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-link",
                              {
                                staticStyle: { "font-size": "12px" },
                                attrs: { type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleBLNo(scope.row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(scope.row.blNo) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "freightName",
                      label: _vm.$t("vipCargo.actualDays"),
                      "min-width": "100px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.tripNumber === "1" &&
                            !_vm.validateNull(scope.row.baseAta) &&
                            !_vm.validateNull(scope.row.atd)
                              ? _c("div", [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.getDiffDay(
                                          scope.row.baseAta,
                                          scope.row.atd
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ])
                              : !_vm.validateNull(scope.row.baseAta) &&
                                !_vm.validateNull(scope.row.baseAtd)
                              ? _c("div", [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.getDiffDay(
                                          scope.row.baseAta,
                                          scope.row.baseAtd
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "freightName",
                      label: _vm.$t("vipCargo.estimatedDays"),
                      "min-width": "120px",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return !_vm.validateNull(scope.row.baseEta) &&
                              !_vm.validateNull(scope.row.baseEtd)
                              ? [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.getDiffDay(
                                          scope.row.baseEta,
                                          scope.row.baseEtd
                                        )
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              : undefined
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "por",
                      label: _vm.$t("vipCargo.por"),
                      "show-overflow-tooltip": "",
                      "min-width": "100px",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "del",
                      label: _vm.$t("vipCargo.del"),
                      "show-overflow-tooltip": "",
                      "min-width": "100px",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "bkServiceLineCode",
                      label: _vm.$t("vipCargo.bkLane"),
                      "min-width": "80px",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "bkVvl",
                      label: _vm.$t("vipCargo.bkVVL"),
                      "show-overflow-tooltip": "",
                      "min-width": "150px",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "baseEtd",
                      label: _vm.$t("vipCargo.etd"),
                      "min-width": "100px",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "baseAtd",
                      label: _vm.$t("vipCargo.atd"),
                      "min-width": "100px",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "releaseStatus",
                      label: _vm.$t("release.releaseStatus"),
                      "min-width": "145px",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "releaseDate",
                      label: _vm.$t("release.releaseDate"),
                      "min-width": "100px",
                      "show-overflow-tooltip": "",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table-column",
                { attrs: { label: _vm.$t("vipCargo.currentVesselMovement") } },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "serviceLineCode",
                      label: _vm.$t("vipCargo.lane"),
                      "min-width": "80px",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "vesselName",
                      label: _vm.$t("vipCargo.vvl"),
                      "show-overflow-tooltip": "",
                      "min-width": "150px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-link",
                              {
                                staticStyle: { "font-size": "12px" },
                                attrs: { type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleVesselCode(scope.row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(scope.row.vesselName) +
                                    " " +
                                    _vm._s(scope.row.voyageNo) +
                                    _vm._s(scope.row.voyageLeg) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "portFrom",
                      label: _vm.$t("vipCargo.pol"),
                      "show-overflow-tooltip": "",
                      "min-width": "100px",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "etd",
                      label: _vm.$t("vipCargo.etd"),
                      "min-width": "100px",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "agtd",
                      label: _vm.$t("vipCargo.agtd"),
                      "min-width": "130px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  scope.row.atd !== null
                                    ? scope.row.atd
                                    : scope.row.agtd !== null
                                    ? scope.row.agtd
                                    : scope.row.cctd !== ""
                                    ? scope.row.cctd
                                    : ""
                                ) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "atd",
                      label: _vm.$t("vipCargo.atd"),
                      "min-width": "130px",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "portTo",
                      label: _vm.$t("vipCargo.pod"),
                      "show-overflow-tooltip": "",
                      "min-width": "100px",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "eta",
                      label: _vm.$t("vipCargo.eta"),
                      "min-width": "100px",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "agta",
                      label: _vm.$t("vipCargo.agta"),
                      "min-width": "130px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  scope.row.ata !== null
                                    ? scope.row.ata
                                    : scope.row.agta !== null
                                    ? scope.row.agta
                                    : scope.row.ccta !== ""
                                    ? scope.row.ccta
                                    : ""
                                ) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "ata",
                      label: _vm.$t("vipCargo.ata"),
                      "min-width": "130px",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table-column",
                { attrs: { label: _vm.$t("vipCargo.nextLeg") } },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "nextTripLine",
                      label: _vm.$t("vipCargo.lane"),
                      "min-width": "80px",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "nextTripVvl",
                      label: _vm.$t("vipCargo.vvl"),
                      "show-overflow-tooltip": "",
                      "min-width": "150px",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table-column",
                { attrs: { label: _vm.$t("vipCargo.moreInfo") } },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "bkPartyName",
                      label: _vm.$t("vipCargo.bookingParty"),
                      "min-width": "150px",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "pic",
                      label: _vm.$t("vipCargo.PIC"),
                      "show-overflow-tooltip": "",
                      "min-width": "150px",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "brokersPic",
                      label: _vm.$t("vipCargo.brokersPIC"),
                      "show-overflow-tooltip": "",
                      "min-width": "150px",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "shipperName",
                      label: _vm.$t("vipCargo.shipper"),
                      "show-overflow-tooltip": "",
                      "min-width": "150px",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "consigneeName",
                      label: _vm.$t("vipCargo.consignee"),
                      "show-overflow-tooltip": "",
                      "min-width": "150px",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "teu",
                      label: _vm.$t("vipCargo.teu"),
                      "min-width": "50px",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "containerNumType",
                      label: "Container",
                      "min-width": "80px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "word-break": "normal !important",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(scope.row.containernumtype) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "containernum",
                      label: "unit",
                      "min-width": "50px",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("el-row", [_vm._v(" ")]),
          _vm._v(" "),
          _c("div", { staticClass: "filter-container-content" }, [
            _c(
              "div",
              { staticClass: "table-container-new" },
              [
                _c(
                  "hot-table",
                  {
                    ref: "hotTable1",
                    attrs: {
                      "data-source": _vm.tableContainerData,
                      settings: _vm.hotSettings1,
                    },
                    on: { rowClick: _vm.rowContainerClick },
                  },
                  [
                    _c("hot-column", {
                      attrs: {
                        data: "blNo",
                        title: _vm.$t("vipCargo.blNo"),
                        "class-name": "htCenter",
                      },
                    }),
                    _vm._v(" "),
                    _c("hot-column", {
                      attrs: {
                        data: "containerNo",
                        title: _vm.$t("vipCargo.containerNo"),
                        "class-name": "htCenter",
                      },
                    }),
                    _vm._v(" "),
                    _c("hot-column", {
                      attrs: {
                        data: "containerType",
                        title: _vm.$t("vipCargo.containerType"),
                        "class-name": "htCenter",
                      },
                    }),
                    _vm._v(" "),
                    _c("hot-column", {
                      attrs: {
                        data: "sealNo",
                        title: _vm.$t("vipCargo.sealNo"),
                        "class-name": "htCenter",
                      },
                    }),
                    _vm._v(" "),
                    _c("hot-column", {
                      attrs: {
                        data: "cargoTypeName",
                        title: _vm.$t("vipCargo.cargoType"),
                        "class-name": "htCenter",
                      },
                    }),
                    _vm._v(" "),
                    _c("hot-column", {
                      attrs: {
                        data: "quantity",
                        title: _vm.$t("vipCargo.quantity"),
                        "class-name": "htCenter",
                      },
                    }),
                    _vm._v(" "),
                    _c("hot-column", {
                      attrs: {
                        data: "weight",
                        title: _vm.$t("vipCargo.weight"),
                        "class-name": "htCenter",
                      },
                    }),
                    _vm._v(" "),
                    _c("hot-column", {
                      attrs: {
                        data: "cntrSize",
                        title: _vm.$t("vipCargo.size"),
                        "class-name": "htCenter",
                      },
                    }),
                    _vm._v(" "),
                    _c("hot-column", {
                      attrs: {
                        data: "currentPort",
                        title: _vm.$t("vipCargo.currentPort"),
                        "class-name": "htCenter",
                      },
                    }),
                    _vm._v(" "),
                    _c("hot-column", {
                      attrs: {
                        data: "movementNameEn",
                        title: _vm.$t("vipCargo.movementNameEn"),
                        "class-name": "htCenter",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            width: "60%",
            title: _vm.titleName,
            visible: _vm.dialogTableVisible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogTableVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "filter-container-content" }, [
            _c(
              "div",
              { staticClass: "table-container-new" },
              [
                _c(
                  "hot-table",
                  {
                    ref: "hotTable1",
                    attrs: {
                      "data-source": _vm.tableMovementData,
                      settings: _vm.hotSettings1,
                    },
                  },
                  [
                    _c("hot-column", {
                      attrs: {
                        data: "eventDate",
                        title: _vm.$t("vipCargo.eventDate"),
                        "class-name": "htCenter",
                      },
                    }),
                    _vm._v(" "),
                    _c("hot-column", {
                      attrs: {
                        data: "eventPort",
                        title: _vm.$t("vipCargo.eventPort"),
                        "class-name": "htCenter",
                      },
                    }),
                    _vm._v(" "),
                    _c("hot-column", {
                      attrs: {
                        data: "movementNameEn",
                        title: _vm.$t("vipCargo.movementNameEn"),
                        "class-name": "htCenter",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("blPrint", { ref: "childPrint" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }